/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Mer informasjon",
  "CookieMessage.old.text":
    "Fot at vår nettbutikk skal fungere bra, bruker vi cookies. Se våre retningslinjer for cookies..",
  "CookieMessage.link": "Aksepter cookies",
  "CookieMessage.more_information": "Les mer om Kramp cookies",
  "CookieMessage.return": "Tilbake",
  "CookieMessage.intro.body":
    "Disse cookies er plassert av Kramp så vel som av tredjepart. Vi tar naturligvis godt vare på ditt personvern. Hvis du klikker på Godta cookies nedenfor, godtar du bruken av disse. Ved å akseptere disse cookies, sikrer du at nettstedet vårt fungerer riktig. Eksempler på hva cookies brukes til, er følgene:",
  "CookieMessage.intro.list.1": "Automatisk innlogging til Min konto",
  "CookieMessage.intro.list.2":
    "Analyse av brukeradferd for å forbedre webshoppen",
  "CookieMessage.intro.list.3":
    "Opprettelse av personlige kundeprofiler slik at vi kan gi deg personlig informasjon og markedsføring",
  "CookieMessage.intro.extra":
    'Hvis du ikke vil akseptere alle cookies, kan du endre dette i <a> innstillingene </a>. For mer informasjon, les <a href="{legalLink}"> informasjon om personvern og cookies </a>',
  "CookieMessage.intro.title": "Kramp bruker cookies",
  "CookieMessage.settings.body":
    "Du kan velge mellom tre cookie-innstillinger. Å velge standardinnstillingen vil gjøre det mulig for oss å gi deg den beste opplevelsen på webshoppen.",
  "CookieMessage.settings.standard.title": "Standard (mest populær):",
  "CookieMessage.settings.standard.body":
    "Cookies brukes til pålogging, bestilling, analyse, personlig informasjon, sosiale medier og cookies fra tredjepart.",
  "CookieMessage.settings.restricted.title": "Begrenset:",
  "CookieMessage.settings.restricted.body":
    "Cookies brukes til pålogging, bestilling, analyse og personlig informasjon.",
  "CookieMessage.settings.highly_restricted.title": "Meget begrenset:",
  "CookieMessage.settings.highly_restricted.body":
    "Du tillater kun et minimum av cookies. Brukes kun ved pålogging, bestilling og tillates kun for at webshoppen skal fungere i rimelig grad.",
  "CookieMessage.settings.options.title": "Her er hva vi gjør:",
  "CookieMessage.settings.option.1":
    "Bruker cookies for å sikre at siden fungerer",
  "CookieMessage.settings.option.2": "Undersøker brukeradferd",
  "CookieMessage.settings.option.3": "Spore personlig statistikk",
  "CookieMessage.settings.option.4":
    "Viser informasjon som kan være av interesse",
  "CookieMessage.settings.option.5": "Bruker informasjon til vår markedsføring",
  "CookieMessage.settings.option.6": "Spore anonym statistikk",
  "CookieMessage.settings.option.7": "Del din personlige informasjon",
  "CookieMessage.settings.title": "Cookie innstillinger",
  "CookiePage.url": "privatliv-cookie-politikk",
};
